import React, { useState} from 'react';
import { useAppSelector } from '../DAL/store';

/**
 * the entry point
 */
const DebugScreenForms: React.FC = () => {

    const [isLoading] = useState(false);

    // test -----------
    const pResult = useAppSelector((store) => store.pResult);
    const formConfiguration = useAppSelector((store) => store.formConfiguration);
    const formComponentList = useAppSelector((store) => store.formComponentList);
    //console.log('formConfiguration: ',formConfiguration);
    return (
        <div className="mx-4">

            {
                !isLoading &&
                <>
                    <div>Debug Redux-------------------------------------------</div>
                    <div>ResultEX: {pResult.resultEX}</div>
                    <div>ResultEXType: {pResult.resultEXType}</div>
                    <div>formConfiguration length: {formConfiguration?.editableAreas?.length}</div>
                    <div>formComponentList length: {formComponentList?.length}</div>
                    <div>Debug screen end-------------------------------------------</div>

                </>
            }

        </div>
    )
};

export default DebugScreenForms;